import { iconClass } from "../enums/icon-class.enum";
import { RouteId } from "../enums/env/routes-id-enum";
import { RouteEnv } from "../interfaces/env/RouteEnv";


export class MainRoute {
  id!: RouteId | null;
  path!: string;
  pathSlash!: string;
  name!: string;
  icon: iconClass | string = "fa-solid fa-table-columns";
  detailBackLink: RouteId | null = null;
  backLinks: RouteId[] = [];
  params: any;
  enabled: boolean = false;
  route!: string;
  subRoutes?: RouteEnv[];

  constructor(dataFromEnv: RouteEnv, routeId: RouteId) {
    if (dataFromEnv) {
      this.id = dataFromEnv.id || null;
      this.path = dataFromEnv.route || '';
      this.pathSlash = '/' + dataFromEnv.route || '';
      this.name = dataFromEnv.name || '';
      this.icon = dataFromEnv.icon || '';
      this.detailBackLink = dataFromEnv.detailBackLink || null;
      this.backLinks = dataFromEnv.backLinks || [];
      this.enabled = dataFromEnv.enabled || false;
      this.params = dataFromEnv.params || null;
      this.route = dataFromEnv.route;
      this.subRoutes = dataFromEnv.subRoutes ?? [];
    } else {
      console.error('Il manque la route dans l\'environement core: ' + routeId);
    }
  }
}
